import {z} from "zod";
import {SALES_DETAIL_TYPE_KEY_TYPE} from "../common/enum";
import {SALES_DETAIL_FORM_STATUS_TYPE} from "./SalesYearlyFormModel";

export const salesWeeklyFormSchema = z.object({
	id: z.string().nullable(),
	type: SALES_DETAIL_TYPE_KEY_TYPE,
	content: z.string(),
	status: SALES_DETAIL_FORM_STATUS_TYPE
});

export type SalesWeeklyFormModel = z.infer<typeof salesWeeklyFormSchema>;
